import { z } from 'zod';
import type { Api } from '@automapa/svelte-automapa-template';

//         /* input: '{address: {"province":"","district":"","community":"","quarter":"","pcode":"05-074","city":"","street":"","house":"","country":"PL"}}' */
export const GeocodeSimpleRequestSchema = z.object({
    address: z.object({
        country: z.coerce.string(),
        province: z.coerce.string().optional(),
        city: z.coerce.string().optional(),
        district: z.coerce.string().optional(),
        community: z.coerce.string().optional(),
        quarter: z.coerce.string().optional(),
        pcode: z.coerce.string().optional(),
        street: z.coerce.string().optional(),
        house: z.coerce.string().optional(),
    }),
});
export type GeocodeSimpleRequestType = z.infer<typeof GeocodeSimpleRequestSchema>;

// {
//   "input" : {
//     "x" : null,
//     "y" : null,
//     "quality" : 0,
//     "countryCodes" : {
//       "iso2" : "",
//       "iso3" : "POL",
//       "targeo" : ""
//     },
//     "country" : "PL",
//     "province" : "",
//     "district" : "",
//     "community" : "",
//     "city" : "",
//     "quarter" : "",
//     "postcode" : "05-074",
//     "street" : "",
//     "house" : "",
//     "mapLink" : "",
//     "house_geoId" : ""
//   },
//   "output" : {
//     "x" : 21.3551218,
//     "y" : 52.22834,
//     "quality" : 3,
//     "countryCodes" : {
//       "iso2" : "PL",
//       "iso3" : "POL",
//       "targeo" : "PL"
//     },
//     "country" : "Polska",
//     "province" : "mazowieckie",
//     "district" : "miński",
//     "community" : "Halinów",
//     "city" : "Halinów",
//     "quarter" : "",
//     "postcode" : "05-074",
//     "street" : "",
//     "house" : "",
//     "mapLink" : "",
//     "house_geoId" : ""
//   }
// }
export const GeocodeSimpleResponseSchema = z.object({
    input: z.object({
        x: z.nullable(z.number()),
        y: z.nullable(z.number()),
        quality: z.number(),
        countryCodes: z.object({
            iso2: z.string(),
            iso3: z.string(),
            targeo: z.string(),
        }),
        country: z.string(),
        province: z.string(),
        district: z.string(),
        community: z.string(),
        city: z.string(),
        quarter: z.string(),
        postcode: z.string(),
        street: z.string(),
        house: z.string(),
        mapLink: z.string(),
        house_geoId: z.string(),
    }),
    output: z.object({
        x: z.number(),
        y: z.number(),
        quality: z.number(),
        countryCodes: z.object({
            iso2: z.string(),
            iso3: z.string(),
            targeo: z.string(),
        }),
        country: z.string(),
        province: z.string(),
        district: z.string(),
        community: z.string(),
        city: z.string(),
        quarter: z.string(),
        postcode: z.string(),
        street: z.string(),
        house: z.string(),
        mapLink: z.string(),
        house_geoId: z.string(),
    }),
});
export type GeocodeSimpleResponseType = z.infer<typeof GeocodeSimpleResponseSchema>;

export class GeocodeSimpleApi {
    public static async geocode(api: Api, input: GeocodeSimpleRequestType): Promise<GeocodeSimpleResponseType> {
        return api.getData<GeocodeSimpleRequestType, GeocodeSimpleResponseType>(
            'post',
            `/location/geocode_simple`,
            input,
            GeocodeSimpleRequestSchema,
            GeocodeSimpleResponseSchema
        );
    }
}
